var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import './bootstrap'; // We require bootstrap to load our DayJS plugins
import 'dayjs/locale/en';
var adapterLocale = process.env.NODE_ENV === 'test' ? 'en' : undefined;
export function DateTimeProvider(_a) {
    var children = _a.children;
    return (_jsx(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs, adapterLocale: adapterLocale }, { children: children })));
}
